import React, { useState } from "react";
import { useMeterReadingFormat } from "../../hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { TableColumn } from "@shared/types/table";
import { GenericTable } from "@shared/components/GenericTable";
import { EyeIcon, PenBox } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectValue,
  SelectTrigger,
} from "@shared/ui/select";
import { Button } from "@shared/ui/button";
import { IconButton } from "@shared/components/IconButton";
import { useNavigate } from "react-router-dom";
import { usePageViewTimer } from "@shared/hooks/usePageViewTimer";

function MeterFormatDashboard() {

 const navigate = useNavigate();
  usePageViewTimer({pageName: 'MX Meter Read Format'})
  const remoteUtilityId = useRemoteUtilityId();
  const [search, setSearch] = useState<string>("");
  const [selectedUtility, setSelectedUtility] = useState<string>("");
  const { data: meterFormat, isLoading } =
  useMeterReadingFormat(remoteUtilityId, search);
  const templateHeaders: TableColumn[] = [
    {
      key: "name",
      header: "Template Name",
      sortable: false,
    },
    {
      key: "utilityService",
      header: "Utility Service",
      sortable: false,
    },
    {
      key: "meterType",
      header: "Read Type",
      sortable: false,
    },
    {
      key: "createdDate",
      header: "Created On",
      sortable: false,
    },
    {
      key: "createdUserRemoteName",
      header: "Created By",
      sortable: false,
    },
  ];

  // Define actions for the table
  const actions = [
    {
      label: "View",
      icon: <EyeIcon className="h-5 w-5 text-muted-foreground" />,
      onClick: (row: any) => {
        navigate(`/mx/settings/meterread-format/view/${row.id}`);
      },
    },
    {
      label: "Edit",
      icon: <PenBox  className="h-5 w-5 text-muted-foreground" />,
      onClick: (row: any) => {
        navigate(`/mx/settings/meterread-format/edit/${row.id}`);
      },
    },
  ];

  // Static pagination (always page 1)
  const pagination = {
    currentPage: 1,
    totalPages: 1,
    totalItems: meterFormat?.length,
    itemsPerPage: meterFormat?.length,
    startItem: 1,
    endItem: meterFormat?.length,
  };

  const handleUtilityChange = (value: string) => {
    setSelectedUtility(value);
  };

  // Clear utility filter
  const clearUtilityFilter = () => {
    setSelectedUtility("");
  };

  // Filter Panel with Utility Select
  const filterPanel = (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <label htmlFor="utility-select" className="text-sm font-medium">
          Utility:
        </label>
        <Select value={selectedUtility} onValueChange={handleUtilityChange}>
          <SelectTrigger className="w-[200px]" id="utility-select">
            <SelectValue placeholder="Select Utility" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="All">All Utilities</SelectItem>
            {/* {utilityOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))} */}
          </SelectContent>
        </Select>
      </div>
      {selectedUtility && (
        <button
          onClick={clearUtilityFilter}
          className="text-sm text-muted-foreground hover:text-foreground underline"
        >
          Clear Filter
        </button>
      )}
    </div>
  );

  return (
    <div>
        <div className="flex items-center justify-between pb-6">
            <span>
            <p className="page-title">Meter Read Formats</p>
            <p className="page-subtitle">Manage all your meter reading formats</p>
            </span>
            <IconButton label="Create New Format" icon="Plus" onClick={()=>{navigate('/mx/settings/meterread-format/add')}} variant="primary" className="bg-primary text-white" />
        </div>
      <GenericTable
        rowKey="id"
        columns={templateHeaders}
        data={meterFormat}
        loading={isLoading}
        actions={actions}
        actionsType="icons"
        emptyMessage="No templates available"
        pagination={pagination}
        onPageChange={() => {}} // No-op since pagination is static
        onSearch={(search) => setSearch(search)}
        searchPlaceholder="Search templates..."
      />
    </div>
  );
}

export default MeterFormatDashboard;
